import { render, staticRenderFns } from "./step02_account.vue?vue&type=template&id=defc5824&"
import script from "./step02_account.vue?vue&type=script&lang=js&"
export * from "./step02_account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports